export default __webpack_public_path__ + "static/media/OCGO-slider4.027fc261.jpg";